export enum LegalStructure {
  FULL_OWNERSHIP = 'FULL_OWNERSHIP',
  INDIVISION = 'INDIVISION',
  SCI = 'SCI',
  SARL_FAMILLE = 'SARL_FAMILLE',
}

export enum TaxRegime {
  IR = 'IR',
  IS = 'IS',
}

export enum SpecialStatus {
  LMNP = 'LMNP',
  MONUMENT_HISTORIQUE = 'MONUMENT_HISTORIQUE',
}

export enum ShareType {
  PERCENTAGE = 'PERCENTAGE',
  TANTIEMES = 'TANTIEMES',
  PARTS_SOCIALES = 'PARTS_SOCIALES',
}

export enum ManagementMode {
  SYNDIC_PRO = 'SYNDIC_PRO',
  SYNDIC_LIBRE = 'SYNDIC_LIBRE',
  NO_COPRO = 'NO_COPRO',
  UNKNOWN = 'UNKNOWN',
}

export enum SyndicLibreType {
  BENEVOLE = 'BENEVOLE',
  COOPERATIF = 'COOPERATIF',
  UNKNOWN = 'UNKNOWN',
}

export enum RentalDeclarationRegime {
  REEL = 'REEL',
  MICRO_FONCIER = 'MICRO_FONCIER',
}

export enum OperationalRole {
  GESTIONNAIRE = 'GESTIONNAIRE',
  PROPRIETAIRE = 'PROPRIETAIRE',
  VISITEUR = 'VISITEUR',
}

export enum OwnershipNature {
  PLEINE_PROPRIETE = 'PLEINE_PROPRIETE',
  USUFRUIT = 'USUFRUIT',
  NUE_PROPRIETE = 'NUE_PROPRIETE',
}

export interface UpdateGovernanceDto {
  legalStructure?: LegalStructure | null;
  taxRegime?: TaxRegime | null;
  specialStatuses?: SpecialStatus[] | null;
  hasDismemberment?: boolean;
  shareType?: ShareType | null;
  totalShares?: number | null;
  managementMode?: ManagementMode | null;
  syndicLibreType?: SyndicLibreType | null;
  rentalDeclarationRegime?: RentalDeclarationRegime | null;
  defaultLocativeShare?: number | null;
}

export interface UpdateMemberGovernanceDto {
  operationalRole?: OperationalRole | null;
  shares?: number | null;
  ownershipNature?: OwnershipNature | null;
  isMandate?: boolean | null;
  hasVotingRights?: boolean | null;
}

export interface UpdateOwnerGovernanceDto {
  ownerOperationalRole?: OperationalRole | null;
  ownerShares?: number | null;
  ownerOwnershipNature?: OwnershipNature | null;
  ownerHasVotingRights?: boolean | null;
}

/**
 * Governance fields present on AssetDetailsDto.
 * Temporary until API client is regenerated.
 */
export interface AssetGovernanceFields {
  legalStructure?: LegalStructure;
  taxRegime?: TaxRegime;
  specialStatuses?: SpecialStatus[];
  hasDismemberment?: boolean;
  shareType?: ShareType;
  totalShares?: number;
  managementMode?: ManagementMode;
  syndicLibreType?: SyndicLibreType;
  currentUserOperationalRole?: OperationalRole;
  currentUserShares?: number;
  currentUserOwnershipNature?: OwnershipNature;
  currentUserHasVotingRights?: boolean;
  ownerOperationalRole?: OperationalRole;
  ownerShares?: number;
  ownerOwnershipNature?: OwnershipNature;
  ownerHasVotingRights?: boolean;
  rentalDeclarationRegime?: RentalDeclarationRegime;
  defaultLocativeShare?: number;
}
